import { createAction } from '@reduxjs/toolkit'

import type { TDataRunsDto } from '@homepal/api-contract'

/**
 * `customerId` is the scope the request was made for (undefined = all
 * customers) and travels on every action, not just the success: the
 * reducer needs it to tell a response apart from a response to an older,
 * differently scoped request. See the reducer's scope guard.
 */
// tryGetDataRuns
export const get = createAction<{ customerId?: string }>(
  'internal_get_data_runs'
)
export const getSuccess = createAction<{
  data: TDataRunsDto
  customerId?: string
}>('internal_get_data_runs_success')
export const getFailed = createAction<{ customerId?: string }>(
  'internal_get_data_runs_failed'
)

// tryStartDataRunJob
export const startJob = createAction<{ jobName: string }>(
  'internal_start_data_run_job'
)
export const startJobSuccess = createAction<{ jobName: string }>(
  'internal_start_data_run_job_success'
)
export const startJobFailed = createAction<{ jobName: string }>(
  'internal_start_data_run_job_failed'
)
